import { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import ChangeForm from './Pages/ChangeForm';
import ConfirmEmailLanding from './Pages/ConfirmEmailLanding';
import ProviderConfirmForm from './Pages/ProviderConfirmForm';
import RequestForm from './Pages/RequestForm';
import ResetForm from './Pages/ResetForm';

import { FormikHelper } from '$HVUI';
import { LoggedOutHeader, UnsupportedHeader } from '$HVUI';
import CookieError from '$UniversalLogin/UniversalLogin/CookieError/CookieError';
import './PasswordManagement.module.less';

const App = props => {
    useEffect(() => {
        window.scrollTo(0, 0);
    });

    const forceValues = props.forceValues || {};
    const pathname = forceValues.pathname || window.location.pathname;

    let initialValues = {
        email: window.email,
        token: window.token,
        uid: window.uidb64
    };

    const isImportedUser = window.canUseImportedUserPasswordSetFlow;
    const hasEmail = !!window.email;

    return (
        <main>
            <FormikHelper>
                <UnsupportedHeader />
                <LoggedOutHeader />
                <CookieError />
                <Switch>
                    <Route
                        exact
                        path="/forgot-password/"
                        component={addlProps => (
                            <RequestForm {...addlProps} />
                        )}
                    />
                    <Route
                        exact
                        path="/provider/account/confirm/:guid(.{32})"
                        component={addlProps => (
                            <ProviderConfirmForm
                                pathname={pathname}
                                {...addlProps}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/secure-password/"
                        component={addlProps => (
                            <ChangeForm
                                isProvider={window.isProvider}
                                isFacilityUser={window.isFacilityUser}
                                {...addlProps}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/confirm-changed/"
                        component={() => <ConfirmEmailLanding />}
                    />
                    <Route
                        path="/reset/:uid(.+)/:token(.{1,13}-.{1,32})/:isBooster?/"
                        component={addlProps => (
                            <ResetForm
                                hasBirthdate={window.hasBirthdate}
                                birthdateExempt={window.birthdateExempt}
                                hasEmail={hasEmail}
                                initialValues={initialValues}
                                isImportedUser={isImportedUser}
                                isProvider={window.isProvider}
                                isFacilityUser={window.isFacilityUser}
                                tokenInvalid={window.tokenInvalid}
                                {...addlProps}
                            />
                        )}
                    />
                </Switch>
            </FormikHelper>
        </main>
    );
};

export default App;
